import styled from "@emotion/styled";

export const Footer = styled.div`
  height: calc(62px + env(safe-area-inset-bottom));
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  padding-bottom: env(safe-area-inset-bottom);
  overflow: visible;
  border-top: 1px solid var(--mantine-color-gray-2);
  background: white;
  box-shadow: 0 -5px 18px rgba(25, 34, 72, 0.07);

  .footer-nav-item {
    --nav-bg: #ffffff;
    min-width: 48px;
    color: #5c6070;
    background: var(--nav-bg);
    border-radius: 11px;
    transition: color 150ms ease, background-color 150ms ease;
  }

  .footer-nav-item[data-active] {
    --nav-bg: var(--mantine-primary-color-0);
    color: var(--mantine-primary-color-7);
  }

  .footer-label {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
  }

  .footer-nav-item[data-active] .footer-label {
    font-weight: 700;
  }

  .calendar-icon,
  .nav-icon {
    position: relative;
    display: flex;
  }

  /* Covers the icon's own digit with today's day of the month. */
  .calendar-day {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    min-width: 12px;
    height: 8px;
    padding: 0 1px;
    background: var(--nav-bg);
    font-size: 8px;
    font-weight: 800;
    line-height: 8px;
    text-align: center;
  }

  .nav-dot {
    position: absolute;
    top: -2px;
    inset-inline-end: -4px;
    width: 10px;
    height: 10px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid var(--nav-bg);
    background: #e03131;
  }

  /* An action, not a destination: a filled button that stays inside the bar. */
  .footer-create {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    min-width: 48px;
    padding: 3px 0;
    color: var(--mantine-primary-color-7);
    -webkit-tap-highlight-color: transparent;
  }

  .footer-create-icon {
    display: grid;
    place-items: center;
    width: 44px;
    height: 32px;
    border-radius: 12px;
    background: var(--mantine-primary-color-7);
    color: #ffffff;
    transition: transform 120ms ease;
  }

  .footer-create:active .footer-create-icon {
    transform: scale(0.94);
  }

  .footer-create .footer-label {
    font-weight: 700;
  }
`;

export const CreateSheetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));

  .create-suggestions {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .create-suggestion {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 64px;
    padding: 10px 12px;
    box-sizing: border-box;
    border-radius: 16px;
    background: var(--mantine-primary-color-0);
    color: var(--mantine-primary-color-9);
  }

  .create-suggestion:active {
    transform: scale(0.99);
  }

  .create-suggestion-icon {
    display: grid;
    place-items: center;
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 13px;
    background: #ffffff;
    color: var(--mantine-primary-color-7);
  }

  .create-suggestion-text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .create-suggestion-text strong {
    font-size: 14.5px;
    font-weight: 800;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .create-suggestion-text span {
    font-size: 12.5px;
    font-weight: 500;
    color: var(--mantine-primary-color-8);
  }

  .create-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .create-action {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 112px;
    padding: 14px;
    box-sizing: border-box;
    border-radius: 18px;
    background: #f4f2ff;
    color: #1f2335;
  }

  .create-action[data-tone="people"] {
    background: #fff4ec;
  }

  .create-action:active {
    transform: scale(0.98);
  }

  .create-icon {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    border-radius: 14px;
    background: #ffffff;
    color: #5243c2;
  }

  .create-action[data-tone="people"] .create-icon {
    color: #b4501a;
  }

  .create-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .create-text strong {
    font-size: 15px;
    font-weight: 800;
  }

  .create-text span {
    font-size: 12px;
    font-weight: 500;
    color: #5f6477;
  }
`;
